import React from 'react';

const Footer = () => (
    <div className="footer">
        <div className="footer__container">
        <h4 className="footer__liner">I teach computers, how to be computers in their own languages.</h4>
        <p className="footer__copy">Copyright &copy; {new Date().getFullYear()} Chetan Audipudy All Rights Reserved</p>
        </div>
    </div>
)

export default Footer